<template>
    <div class="loading-wave-container">
        <div class="loading-waves">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="loading-text" v-if="showText">{{ text }}</div>
    </div>
</template>

<script>
export default {
    name: "LoadingWave",
    props: {
        text: {
            type: String,
            default: "Veriler yükleniyor..."
        },
        showText: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style scoped lang="scss">
.loading-wave-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .loading-waves {
        display: flex;
        align-items: center;
        height: 30px;
        margin-bottom: 10px;

        span {
            display: block;
            width: 4px;
            margin: 0 3px;
            background-color: #1890ff;
            animation: wave 1.2s infinite ease-in-out;

            &:nth-child(1) {
                height: 15px;
                animation-delay: 0s;
            }
            &:nth-child(2) {
                height: 22px;
                animation-delay: 0.3s;
            }
            &:nth-child(3) {
                height: 30px;
                animation-delay: 0.6s;
            }
            &:nth-child(4) {
                height: 22px;
                animation-delay: 0.9s;
            }
        }
    }

    .loading-text {
        font-size: 14px;
        color: #1890ff;
        font-weight: bold;
    }
}

@keyframes wave {
    0%, 100% {
        transform: scaleY(0.5);
    }
    50% {
        transform: scaleY(1);
    }
}
</style> 